import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import { ActiveSearchModel } from 'domain/entities/active-search-model'
import ActiveSearchDataGrid from 'presentation/hospital/components/Tables/ActiveSearchDataGrid'
import {
  ActiveSearchSurgeryTranslated,
  ActiveSearchSurgeryType
} from 'common/enum/active-search-surgery-type'
import { ActiveSearchHelpStatus } from 'common/enum/active-search-help-status'
import {
  WithLoading,
  WithLoadingProps
} from 'presentation/shared/components/HOCs/WithLoading'
import { toast } from 'react-toastify'
import { LoadActiveSearchType } from 'domain/usecases/active-search/load-active-search-type'
// import * as S from './styles'

type Props = {
  currentHospitalId: number
  loadActiveSearchType: LoadActiveSearchType
} & WithLoadingProps

type LocationType = {
  headerTitle: string
  startDate: string
  endDate: string
  type?: ActiveSearchSurgeryType
  status?: ActiveSearchHelpStatus
}

const ActiveSearchDetailsLayout = WithLoading(
  ({ currentHospitalId, loadActiveSearchType, setIsLoading }: Props) => {
    const { state } = useLocation<LocationType>()
    const history = useHistory()
    const [dataGridData, setDataGridData] = useState<ActiveSearchModel[]>([])

    const handleLoadActiveSearchType = async () => {
      setIsLoading(true)
      try {
        const response = await loadActiveSearchType.load({
          startDate: state.startDate,
          endDate: state.endDate,
          type: state?.type,
          status: state?.status
        })

        setDataGridData(response)
      } catch (error) {
        toast.error('Ocorreu um erro ao realizar a busca ativa')
      } finally {
        setIsLoading(false)
      }
    }

    useEffect(() => {
      if (state?.startDate && state?.endDate) {
        handleLoadActiveSearchType()
      } else {
        history.goBack()
      }
    }, [currentHospitalId])

    return (
      <>
        <HeadingNew
          size="xlarge"
          color="secondary700"
          lineHeight="xlarge"
          style={{ marginBottom: '32px' }}
        >
          {state?.headerTitle ?? ActiveSearchSurgeryTranslated.ALL}
        </HeadingNew>
        <ActiveSearchDataGrid
          data={dataGridData}
          type={state?.type}
          // status={state?.status}
        />
      </>
    )
  }
)

export default ActiveSearchDetailsLayout
